import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconDomainZS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.5 2C4.22386 2 4 2.22386 4 2.5L4 12.2929L2.85355 11.1464C2.65829 10.9512 2.34171 10.9512 2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536L4.14645 13.8536C4.34171 14.0488 4.65829 14.0488 4.85355 13.8536L6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464C6.65829 10.9512 6.34171 10.9512 6.14645 11.1464L5 12.2929L5 2.5C5 2.22386 4.77614 2 4.5 2Z"
        fill="#97B2C4"
      />
      <path
        d="M8.02365 13V11.8721L12.1629 4.51856H8V3L13.9763 3V4.12793L9.841 11.4814H14V13H8.02365Z"
        fill="#97B2C4"
      />
    </svg>
  )
}

export const IconDomainZ = createIcon({
  l: IconDomainZS,
  m: IconDomainZS,
  s: IconDomainZS,
  xs: IconDomainZS,
  name: 'IconDomainZ',
})
